import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { color, border } from 'styled-system';

const Wrapper = styled.div`
  border: solid 1px;
  border-radius: 8px;
  ${color};
  ${border};
  width: 186px;
  height: 233px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 16px;
  margin-bottom: 16px;
`;

const IconWrapper = styled.div`
  margin: 75px 0 40px;
`;

const Text = styled.p`
  font-family: 'Montserrat';
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-top: 0;
`;

export default function TileCard({ icon, text, id, handleClick, className }) {
  const [currentColor, setCurrentColor] = useState('primary.100');
  return (
    <Wrapper
      onClick={handleClick}
      id={id}
      color={currentColor}
      borderColor="black.10"
      className={className}
      onMouseEnter={() => setCurrentColor('primary.80')}
      onMouseLeave={() => setCurrentColor('primary.100')}
      onMouseDown={() => setCurrentColor('primary.120')}
      onMouseUp={() => setCurrentColor('primary.80')}
    >
      <IconWrapper>
        <i className={icon} color={color}></i>
      </IconWrapper>
      <Text>{text}</Text>
    </Wrapper>
  );
}

TileCard.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
  id: PropTypes.string,
  handleClick: PropTypes.func,
  className: PropTypes.string,
};
